import { GET_CARDS } from "constants/cards";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CARDS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
